import { Routes } from '@angular/router'
import { EAppVerifyComponent } from '../e-app-beneficiary/component/e-app-verify.component'
import { EAppVerifyStep2Component } from '../e-app-beneficiary/component/e-app-verify-Step2.component'
import { EAppVerifyStep3Component } from '../e-app-beneficiary/component/e-app-verify-Step3.component'
import { EAppEnrollmentButtonComponent } from '../e-app-beneficiary/component/e-app-verify-correction.component'
import { EAppEnrollmentMessagesComponent } from '../e-app-beneficiary/component/e-app-verify-messages.component'
export const EAppBeneficiaryRoutes: Routes = [
    {
        path: 'verify/:guid',
        component: EAppVerifyComponent
    },
    {
        path: 'Step2/:guid',
        component: EAppVerifyStep2Component
    },
    {
        path: 'Step3/:guid',
        component: EAppVerifyStep3Component
    }
    ,
    {
        path: 'confirmation/:guid/:id/:icid',
        component: EAppEnrollmentButtonComponent
    },
    {
        path: 'messages/:id/:icid',
        component: EAppEnrollmentMessagesComponent
    }
]
